<div style=" padding: 20px">
  <h4>Floor plan for {{data.unitNumber}} ({{data.floorPlan.images.length}} {{data.floorPlan.images.length > 1 ? 'images' : 'image'}})</h4>
  <div style="display: flex; flex-direction: column; max-height: 600px; overflow: scroll">
    <img *ngFor="let i of data.floorPlan.images" [src]="SERVER_URL +'images/' + data.projectCode + '/floor_plans/' + i.fileName"
      style="margin-bottom: 20px; object-fit: contain; width: 100%">
  </div>

</div>